import React , {useEffect, useState } from "react";
import { GetProfileImages } from "../../DocumentDetails/slice";
import CalendarMonthOutlinedIcon from "@mui/icons-material/CalendarMonthOutlined";
import { Box, Stack, Typography,   Button, Tooltip,  Grid,TextField, Badge,} from "@mui/material";
import LocationOnOutlinedIcon from "@mui/icons-material/LocationOnOutlined";
import DirectionsOutlinedIcon from "@mui/icons-material/DirectionsOutlined";
import dayjs from "dayjs";
import "dayjs/locale/pt";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DateTimePicker } from "@mui/x-date-pickers/DateTimePicker";
import FormControlLabel from "@mui/material/FormControlLabel";
import Checkbox from "@mui/material/Checkbox";
import FormGroup from "@mui/material/FormGroup";
import CloseOutlinedIcon from "@mui/icons-material/CloseOutlined";
import CheckCircleOutlineOutlinedIcon from "@mui/icons-material/CheckCircleOutlineOutlined";
import { useDispatch, useSelector } from "react-redux";
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import { useSnackbar } from "notistack";
import InfoIcon from "@mui/icons-material/Info";
import CollectionProductsEventos from "../../../components/CollectionDonationCard/CollectionProductsEventos"
import {
  setEndDate,
  setStartDate,
  setUpdateDonationDetail,
  updateDonation,
  setDonationTab,
  setSelectProductError,
  setAnimalEndDate,
  addCollectorInviteForDonation,
} from "../../DonationView/slice";
import { EntityType } from "../../../common/enum";
import Avatar from "@mui/material/Avatar";
import { DEFAULT_AVATAR_URL } from "../../../common/enum";
const Detail = ({ donationDetail, t }) => {
  

  const {
    auth: {
      profile: { entity },
    },
    donationCart: {
      updateDonationDetail,
      startDate,
      endDate,
      donationType,
      selectProductError,
      animalEndDate,
      donationId,
    },
    dashboardInfo: { myActiveDonationsOffSet, myActiveDonationsLimit, entityProfileSelect },
  } = useSelector((state) => state);
  const dispatch = useDispatch();
  const [isAnimalCheckedReject, setIsAnimalCheckedReject] = React.useState(false);
  const [isAnimalChecked, setIsAnimalChecked] = React.useState(false);
  const [animalEndDateValue, setAnimalEndDateValue] = React.useState(null);
  const [dateValue, setDateValue] = React.useState(donationDetail?.donation?.expiryDate);
  const [reasonAnimalEndDate, setReasonAnimalEndDate] = React.useState(" ");
  const [errorAnimalEndDate, setErrorAnimalEndDate] = React.useState(false);
  const { enqueueSnackbar } = useSnackbar();

  function toLocalISOString(inputDate) {
    const date = inputDate instanceof Date ? inputDate : new Date(inputDate);
  
    if (isNaN(date)) {
      throw new Error('Invalid date');
    }
  
    const offsetMs = date.getTimezoneOffset() * 60000;
    const adjustedDate = new Date(date.getTime() - offsetMs);
    return adjustedDate.toISOString().slice(0, -1);
  }

  const endAnimalHandleChange = (newValue) => {
    setAnimalEndDateValue(newValue);
    if (!Number.isNaN(new Date(newValue).getTime()) && newValue !== null) {
      const payload = {
        ...updateDonationDetail,
        isAnimal: true,
        consumedByDate: toLocalISOString(newValue),
        donationId: donationDetail?.donation?.donationId,
       
      };

    const availableToDate = new Date(donationDetail?.donation?.expiryDate);
    const consumedByDate = new Date(payload.consumedByDate);

    const timeDifference = consumedByDate - availableToDate;
    const hoursDifference = timeDifference / (1000 * 60 * 60);
    const hasPassed24Hours = hoursDifference >= 1;

    if(hasPassed24Hours ==  false){
      setErrorAnimalEndDate(true);
      setReasonAnimalEndDate(t("invalidDate"));
    }else{
      setErrorAnimalEndDate(false);
      setReasonAnimalEndDate(" ");
    }
    dispatch(setUpdateDonationDetail(payload));
    dispatch(setAnimalEndDate(false));
    }
  };

  const handleAnimalChange = (e) => {
    setIsAnimalChecked(e.target.checked);
    const payload = {
      ...updateDonationDetail,
      isAnimal: e.target.checked,
      donationId: donationDetail?.donation?.donationId,
      status: "AlternativeChannel"
    };
    dispatch(setUpdateDonationDetail(payload));
  };

  const handleAnimalChangeReject = (e) => {
    setIsAnimalCheckedReject(e.target.checked);
    const payload = {
      ...updateDonationDetail,
      isAnimal: !e.target.checked,
      donationId: donationDetail?.donation?.donationId,
      status: "AlternativeChannel"
    };
    dispatch(setUpdateDonationDetail(payload));
  };

  const onContinue = async () => {
    if(donationDetail?.donation?.isAnimal == true){
      if(isAnimalCheckedReject ==  true){
        if (Object.keys(updateDonationDetail).length > 0) {
            dispatch(updateDonation(updateDonationDetail))
              .unwrap()
              .then(() => {
                enqueueSnackbar({
                  message: "Canal alternativo rejeitado com sucesso",
                  variant: "success",
                });
                window.location.reload();
              })
              .catch((err) => {
                enqueueSnackbar({
                  message: t("failedToUpdateDonation"),
                  variant: "error",
                });
              });
        }
      }else{
        enqueueSnackbar({
          message: "Para rejeitar tem de selecionar a opção",
          variant: "error",
        });
      }
    }
    else if(isAnimalChecked== true && errorAnimalEndDate === true){
      enqueueSnackbar({
        message: "Data inválida",
        variant: "error",
      });
    }else{
      if (Object.keys(updateDonationDetail).length > 0) {
        if (updateDonationDetail["isAnimal"] === true && updateDonationDetail["consumedByDate"] === undefined) {
          enqueueSnackbar({
            message: "Data inválida",
            variant: "error",
          });
        } else {
          
          dispatch(updateDonation(updateDonationDetail))
            .unwrap()
            .then(() => {
              enqueueSnackbar({
                message: t("donationCreatedSuccessfully"),
                variant: "success",
              });
              window.location.reload();
            })
            
            .catch((err) => {
              enqueueSnackbar({
                message: t("failedToUpdateDonation"),
                variant: "error",
              });
            });
        }
      }
    }
  };

const [profileImages, setProfileImages] = useState(new Map());

useEffect(() => {
  const fetchImages = async () => {
    const list = donationDetail?.entidadeBeneficiaria;

    if (!Array.isArray(list)) return; // Garante que só itera se for array

    const newMap = new Map();

    for (const item of list) {
      const id = item?.entityLeastDetails?.[0]?.profilePicture;
      if (id && id !== "string") {
        try {
          const result = await dispatch(GetProfileImages(id)).unwrap();
          const imageUrl = result?.isActive; // ou result?.imageUrl, dependendo da resposta da API
          if (imageUrl != null) {
            newMap.set(item.entityId, imageUrl);
          }else{
              newMap.set(item.entityId, DEFAULT_AVATAR_URL);
          }
        } catch (err) {
          console.warn("Erro ao buscar imagem:", err);
        }
      }
    }

    setProfileImages(newMap);
  };

  fetchImages();
}, [donationDetail?.entidadeBeneficiaria, dispatch]);

  let currentTimeZone = new Intl.DateTimeFormat().resolvedOptions().timeZone;
  return (
    <Box sx={{ mt: 2, p: 2 }}>
      {donationDetail?.donation?.status == 'CANCELLED' &&
             <Box 
             sx={{
               backgroundColor: `#FFE2E2`,
               display: "flex",
               borderRadius: 1.5,
               padding: '8px',
               width: 1,
               alignItems: "center" ,
               mb: 3,
               border: '1px solid #DC2600'

             }}
           >
            <InfoIcon
              sx={{
                backgroundColor: `#DC2600`,
                color: "white",
                width: 32,
                height: 32,
                padding: 0.5,
                borderRadius: "10px",
              }}
             />
             <Typography variant="body2" fontWeight={600} paddingLeft={"8px"} >
                {t("cancelled")}
             </Typography>
           </Box>
            }
            { !donationDetail?.donation.isAnimal  && new Date(donationDetail?.donation?.expiryDate) > new Date() && (donationDetail?.donation?.status == 'NEW' || donationDetail?.donation.status == "PARTIAL" || donationDetail?.donation.status == "RESERVED")&& (entity?.entityType === EntityType.donor ||
              entityProfileSelect === EntityType.donor) &&
              (entity?.isParentEntity === false ||entity?.parentEntityId !== null ||entity?.isGroupEntity === false)
              &&
             <Box 
             sx={{
               backgroundColor: `#FFFBD4`,
               display: "flex",
               borderRadius: 1.5,
               p: 1.5,
               width: 1,
               alignItems: "center" ,
               mb: 3

             }}
           >
             <InfoIcon
               sx={{
                 backgroundColor: `#EE9500`,
                 color: "white",
                 width: 32,
                 height: 32,
                 padding: 0.5,
                 borderRadius: "10px",
                 marginBottom:'auto'
               }}
             />
            
                <Box sx={{display:"block" , alignItems:"center", ml:2}}>

              <FormGroup sx={{display:"block" , alignItems:"center"}}>
                <FormControlLabel
                // required
                control={
                  <Checkbox
                  checked={isAnimalChecked}
                  onChange={handleAnimalChange}
                  />
                }
                label={t("alternativeAnimalChannel")}
                sx={{ marginRight:"4px"}}
                />
                <Tooltip
                title={"(ex.: Canis/Gatis, Zoos) Caso não seja possível canalizar para a alimentação humana a totalidade da sua doação, ao selecionar esta opção do canal alternativo as entidades recetoras da alimentação animal irão receber uma notificação após o término da recolha que definiu para a alimentação humana. Adicionalmente, deve definir a data e horário final para a recolha destinada à alimentação animal (ex.: Canis/Gatis, Zoos), tendo presente que terá de estabelecer o horário final de recolha para estas entidades com pelo menos 1 hora depois do término da recolha definido para a alimentação humana."}>
                <InfoOutlinedIcon sx={{color:"#37B34A" ,  marginRight:"9px"}}/>
                </Tooltip>
              </FormGroup>
             <Box>
             {isAnimalChecked && (
                <LocalizationProvider
                dateAdapter={AdapterDayjs}
                adapterLocale={"pt"}
                >
                <DateTimePicker
                 dayOfWeekFormatter={(day) => {
                  const map = {
                    "2ª": "S",  // Segunda
                    "3ª": "T",  // Terça
                    "4ª": "Q",  // Quarta
                    "5ª": "Q",  // Quinta
                    "6ª": "S",  // Sexta
                    "Sa": "S",  // Sábado
                    "Do": "D",  // Domingo
                  };
                  return map[day] ?? day;
                }}
                  className="datePickerCA"
                  disablePast
                  label={t("endDate")}
                  ampm={false}
                  value={animalEndDateValue}
                  sx={{ mr: 1}}
                  // minDate={startDateValue}
                  minDateTime={dayjs(dateValue).add(1, "hour")}
                  onChange={endAnimalHandleChange}
                  inputFormat="DD/MM/YYYY HH:mm"
                 
                  renderInput={(props) => (
                  <TextField
                   
                    {...props}
                    error={
                    errorAnimalEndDate === true ||
                    animalEndDate === true
                      ? true
                      : false
                    }
                    helperText={
                      
                    animalEndDate
                      ? "Selecione a doação disponível até o momento"
                      : reasonAnimalEndDate
                    }
                  />
                  )}
                />
                <Button
                  
                  variant="contained"
                  onClick={() => onContinue()}
                  endIcon={<CheckCircleOutlineOutlinedIcon fontSize="16px" />}
                  sx={{borderRadius:"4px",height: "56px",marginLeft: "11px"}}
                >
                  <Typography variant="bold">Submeter</Typography>
                </Button>
                </LocalizationProvider>
               
              )}
             </Box>
              
            </Box> 
      
           </Box>
            }{ donationDetail?.donation.isAnimal  && new Date(donationDetail?.donation?.consumeByDate) > new Date() && (donationDetail?.donation?.status == 'NEW' || donationDetail?.donation.status == "PARTIAL" || donationDetail?.donation.status == "RESERVED")&& (entity?.entityType === EntityType.donor ||
              entityProfileSelect === EntityType.donor) &&
              (entity?.isParentEntity === false ||entity?.parentEntityId !== null ||entity?.isGroupEntity === false)
              &&
             <Box 
             sx={{
               backgroundColor: `#FFFBD4`,
               display: "flex",
               borderRadius: 1.5,
               p: 1.5,
               width: 1,
               alignItems: "center" ,
               mb: 3

             }}
           >
             <InfoIcon
               sx={{
                 backgroundColor: `#EE9500`,
                 color: "white",
                 width: 32,
                 height: 32,
                 padding: 0.5,
                 borderRadius: "10px",
                 marginBottom:'0'
               }}
             />
            
                <Box sx={{display:"block" , alignItems:"center", ml:2}}>

              <FormGroup sx={{display: "block"}}>
                <FormControlLabel
                // required
                control={
                  <Checkbox
                  checked={isAnimalCheckedReject}
                  onChange={handleAnimalChangeReject}
                  />
                }
                label={"Rejeitar canal alternativo"}
                sx={{ marginRight:"4px"}}
                />
                <Tooltip
                title={"(ex.: Canis/Gatis, Zoos)"}>
                <InfoOutlinedIcon sx={{color:"#37B34A" ,  marginRight:"9px"}}/>
                </Tooltip>
                <Button
                  variant="contained"
                  onClick={() => onContinue()}
                  endIcon={<CheckCircleOutlineOutlinedIcon fontSize="16px" />}
                  sx={{borderRadius:"4px",height: "56px",marginLeft: "11px"}}
                >
                  <Typography variant="bold">Submeter</Typography>
                </Button>
              </FormGroup>
            </Box> 
           </Box>
            }
             {!donationDetail?.donation.isAnimal && new Date(donationDetail?.donation?.expiryDate) < new Date() && donationDetail?.donation?.status != 'CANCELLED' && donationDetail?.donation.status != 'COLLECTED' && (entity?.entityType === EntityType.donor ||
              entityProfileSelect === EntityType.donor) &&
              (
                entity?.isParentEntity === false ||
                entity?.parentEntityId !== null ||
                entity?.isGroupEntity === false) && new Date(donationDetail?.donation.expiryDate) < new Date() 
                &&
             <Box 
             sx={{
               backgroundColor: `#FFFBD4`,
               display: "flex",
               borderRadius: 1.5,
               p: 1.5,
               width: 1,
               alignItems: "center" ,
               mb: 3

             }}
           >
             <InfoIcon
               sx={{
                 backgroundColor: `#EE9500`,
                 color: "white",
                 width: 32,
                 height: 32,
                 padding: 0.5,
                 borderRadius: "10px",
                 marginBottom:'auto'
               }}
             />
             <Typography variant="body2" fontWeight={600} mx={2}>
                {'O período desta doação chegou ao fim'}

                <Box sx={{display:"block" , alignItems:"center"}}>

              <FormGroup sx={{display:"block" , alignItems:"center"}}>
                <FormControlLabel
                // required
                control={
                  <Checkbox
                  checked={isAnimalChecked}
                  onChange={handleAnimalChange}
                  />
                }
                label={t("alternativeAnimalChannel")}
                sx={{ marginRight:"4px"}}
                />
                <Tooltip
                title={"(ex.: Canis/Gatis, Zoos) Caso não seja possível canalizar para a alimentação humana a totalidade da sua doação, ao selecionar esta opção do canal alternativo as entidades recetoras da alimentação animal irão receber uma notificação após o término da recolha que definiu para a alimentação humana. Adicionalmente, deve definir a data e horário final para a recolha destinada à alimentação animal (ex.: Canis/Gatis, Zoos), tendo presente que terá de estabelecer o horário final de recolha para estas entidades com pelo menos 1 hora depois do término da recolha definido para a alimentação humana."}>
                <InfoOutlinedIcon sx={{color:"#37B34A" ,  marginRight:"9px"}}/>
                </Tooltip>
              </FormGroup>
             <Box>
             {isAnimalChecked && (
                <LocalizationProvider
                dateAdapter={AdapterDayjs}
                adapterLocale={"pt"}
                >
                <DateTimePicker
                 dayOfWeekFormatter={(day) => {
                  const map = {
                    "2ª": "S",  // Segunda
                    "3ª": "T",  // Terça
                    "4ª": "Q",  // Quarta
                    "5ª": "Q",  // Quinta
                    "6ª": "S",  // Sexta
                    "Sa": "S",  // Sábado
                    "Do": "D",  // Domingo
                  };
                  return map[day] ?? day;
                }}
                  className="datePickerCA"
                  disablePast
                  label={t("endDate")}
                  ampm={false}
                  value={animalEndDateValue}
                  sx={{ mr: 1}}
                  // minDate={startDateValue}
                  minDateTime={dayjs(dateValue).add(1, "day")}
                  onChange={endAnimalHandleChange}
                  inputFormat="DD/MM/YYYY HH:mm"
                 
                  renderInput={(props) => (
                  <TextField
                   
                    {...props}
                    error={
                    errorAnimalEndDate === true ||
                    animalEndDate === true
                      ? true
                      : false
                    }
                    helperText={
                      
                    animalEndDate
                      ? "Selecione a doação disponível até o momento"
                      : reasonAnimalEndDate
                    }
                  />
                  )}
                />
                <Button
                  
                  variant="contained"
                  onClick={() => onContinue()}
                  endIcon={<CheckCircleOutlineOutlinedIcon fontSize="16px" />}
                  sx={{borderRadius:"4px",height: "56px",marginLeft: "11px"}}
                >
                  <Typography variant="bold">Submeter</Typography>
                </Button>
                </LocalizationProvider>
               
              )}
             </Box>
              
            </Box> 
             </Typography>
           </Box>
            }
            
            <Typography variant="h6" color="text.secondary">
                Recolha
              </Typography>
              <Box sx={{ width: 1, display: "flex", alignItems: "center" }}>
                <CalendarMonthOutlinedIcon />
                <Typography
                  variant="body2"
                  sx={{ ml: 2 }}
                  textTransform={"capitalize"}
                >
                  {t("in")}{" "}
                  <span>
                    {new Date(
                      donationDetail?.donation.availableFromDate
                    ).toLocaleString("pt-PT", {
                      day: "numeric",
                      month: "numeric",
                      year: "numeric",
                      hour: "numeric",
                      minute: "numeric",
                      formatMatcher: "best fit",
                    })}
                  </span>{" "}
                  {t("until")}{" "}
                  <span>
                    {new Date(donationDetail?.donation.expiryDate).toLocaleString(
                      "pt-PT",
                      {
                        day: "numeric",
                        month: "numeric",
                        year: "numeric",
                        hour: "numeric",
                        minute: "numeric",
                        formatMatcher: "best fit",
                      }
                    )}
                  </span>
                </Typography>
                </Box>
              {donationDetail?.donation?.consumeByDate && (
                <>
                <Typography variant="h6" color="text.secondary" sx={{mt:3}}>
                  Recolha do canal alternativo
                </Typography>
                 
                  <Box sx={{ width: 1, display: "flex", alignItems: "center" }}>
                  <CalendarMonthOutlinedIcon />
                    <Typography
                      variant="body2"
                      sx={{ ml: 2 }}
                      textTransform={"capitalize"}
                    >
                      {t("in")}{" "}
                      <span>
                        {new Date(donationDetail?.donation.expiryDate).toLocaleString("pt-PT", {
                          day: "numeric",
                          month: "numeric",
                          year: "numeric",
                          hour: "numeric",
                          minute: "numeric",
                          formatMatcher: "best fit",
                        })}
                      </span>{" "}
                      {t("until")}{" "}
                      <span>
                        {new Date(donationDetail?.donation.consumeByDate).toLocaleString(
                          "pt-PT",
                          {
                            day: "numeric",
                            month: "numeric",
                            year: "numeric",
                            hour: "numeric",
                            minute: "numeric",
                            formatMatcher: "best fit",
                          }
                        )}
                      </span>
                    </Typography>
                  </Box>
                </>
              )}
              <Box
                sx={{
                  width: 1,
                  display: "flex",
                  alignItems: "flex-start",
                  mt: 2,
                  justifyContent: "space-between",
                }}
              >
                <Box sx={{ display: "flex" }}>
                  <LocationOnOutlinedIcon />
                  <Stack direction={"column"} ml={2}>
                    {/* <Typography>
                        {donationDetail?.addresses != undefined && donationDetail?.addresses != null &&
                        donationDetail?.addresses[0].isHeadquarter == false ?
                        donationDetail?.addresses[0].entityName :
                        donationDetail?.entityLeastDetails?.entityName != null ? donationDetail?.entityLeastDetails?.entityName : entity?.entityName}
                    </Typography> */}
                    <Typography>{donationDetail?.addresses[0]?.addressLine}</Typography>
                    <Typography>{donationDetail?.addresses[0]?.district}</Typography>
                    <Typography>{donationDetail?.addresses[0]?.county}</Typography>
                    <Typography>{donationDetail?.addresses[0]?.subDivision}</Typography>
                    <Typography>{donationDetail?.addresses[0]?.postalCode}</Typography>
                    <Typography>{donationDetail?.addresses[0]?.locality}</Typography>
                    <Typography
                      color="primary"
                      sx={{ textDecoration: "underline" }}
                    >
                      {donationDetail?.addresses[0]?.latitude},
                      {donationDetail?.addresses[0]?.longitude}
                    </Typography>
                  </Stack>
                </Box>
                {/* <Button
                  variant="outlined"
                  endIcon={
                    <DirectionsOutlinedIcon sx={{ color: "text.primary" }} />
                  }
                  size={"large"}
                  onClick={() => setMapOpen(true)}
                  sx={{
                    color: "text.secondary",
                    borderRaidus: 0,
                    background: "#e1efb0",
                    borderRadius: "4px",
                  }}
                >
                  {distance.toFixed(2)} km
                </Button> */}
              </Box>
              <Stack direction="column" gap="6px" pt={3} pb={2}>
              <Typography
                variant="h6"
                color={"text.secondary"}
                fontWeight={600}
              >
                {"Doação disponível para entidades excluídas"}
              </Typography>
              <Typography variant="body1">
                {donationDetail?.donation?.isblocked ? "Não disponível"  : "Disponível"}
              </Typography>
            </Stack>
              <Stack direction="column" gap="6px" pt={3} pb={2}>
              <Typography
                variant="h6"
                color={"text.secondary"}
                fontWeight={600}
              >
                {t("alternativeAnimalChannel")}
              </Typography>
              <Typography variant="body1">
                {donationDetail?.donation?.isAnimal ? t("permitted") : t("notPermitted")}
              </Typography>
            </Stack>
            {donationDetail?.entidadeBeneficiaria != null && (
              <>
              <Typography variant="h6" color="text.secondary" sx={{mb:2}}>
                  {"Entidade(s) beneficiária(s)"}
                </Typography>
                <Box sx={{ display: "flex", alignItems: "flex-start",paddingBottom: "12px",flexDirection: "column" }}>
              {donationDetail.entidadeBeneficiaria.map((item) =>
              <>
                <Box sx={{display: "flex",flexDirection: "row",alignItems: "center" , marginBottom: "5px"}}>
                <Avatar
                alt={item.entityName}
                sx={{
                backgroundColor: "green",
                "& img": {
                  height:
                  item?.entityLeastDetails[0].profilePicture === "string" ||
                  item?.entityLeastDetails[0].profilePicture === null
                    ? "100%"
                    : "100%",
                  width:
                  item?.entityLeastDetails[0].profilePicture === "string" ||
                  item?.entityLeastDetails[0].profilePicture === null
                    ? "100%"
                    : "100%",
                },
                }}
                src={
                  item?.entityLeastDetails[0].profilePicture === "string" ||
                  item?.entityLeastDetails[0].profilePicture === null
                  ? DEFAULT_AVATAR_URL
                  : profileImages.get(item?.entityId)
                }
              />
            <Typography variant="body1" sx={{marginLeft: "5px"}}>
              {item.entityName}
            </Typography>
                </Box>
              </>
              )} 
                </Box>
              </>
            )}
            {/* {donationDetail?.donation?.isAnimal && (
              <Stack
                direction={"row"}
                alignItems="center"
                justifyContent={"space-between"}
                width={1}
              >
                <Typography variant="h6" fontWeight={600}>
                  {t("alternativeChannelEndDate")}
                </Typography>
                <Typography variant="body1">
                  {new Date(
                    donationDetail?.donation?.consumeByDate + "Z"
                  ).toLocaleString("pt-PT", {
                    day: "numeric",
                    month: "numeric",
                    year: "numeric",
                    hour: "numeric",
                    minute: "numeric",
                    formatMatcher: "best fit",
                    timeZone: currentTimeZone,
                  })}
                </Typography>
              </Stack>)} */}
              {donationDetail.donation.isEvent == true &&
             <Box >
             <Typography
                 variant="h6"
                 color="text.secondary"
                
               >
                 {"Produtos eventualmente disponíveis"}
               </Typography>
               
               <Box sx={{ display: "block", alignItems: "center" }}>
             
               <CollectionProductsEventos
                products={donationDetail?.donation.eventProductsInformation != null ? donationDetail?.donation.eventProductsInformation.split(";") : []}
                t={t}
               // collectionProduct={collectionProduct}
               // setCollection={setCollection}
                //setProductError={setProductError}
               // componentType={ComponentType.DISTRIBUTOR_DONATION_PRODUCT}
              />
                
              </Box>
             </Box>
            }
              <Stack direction="column" gap="6px" pb={4}>
                <Typography
                  variant="h6"
                  color={"text.secondary"}
                  fontWeight={600}
                  textTransform={"capitalize"}
                >
                  {t("observations")}
                </Typography>
                <Typography variant="body1">
                  {donationDetail?.donation?.note
                    ? donationDetail?.donation?.note
                    : "Sem observações"}
                </Typography>
              </Stack>
            </Box>






    ///////////////////
    // <Box sx={{ width: 1, p: 2 }}>
    
    //   <Stack direction="column" gap="6px" pb={4}>
    //     <Typography variant="h6" color={"text.secondary"}>
    //       {t("period")}
    //     </Typography>
    //     {Object.keys(donationDetail).length > 0 && (
    //       <Stack mt={2} direction={"column"} gap={1}>
    //         <Stack direction="column" gap="6px" pt={3} pb={1 }>
    //           <Typography
    //             variant="h6"
    //             color={"text.secondary"}
    //             fontWeight={600}
    //           >
    //             {t("alternativeAnimalChannel")}
    //           </Typography>
    //           <Typography variant="body1">
    //             {donationDetail?.donation?.isAnimal ? t("permitted") : t("notPermitted")}
    //           </Typography>
    //         </Stack>
    //         {donationDetail?.donation?.isAnimal && (
    //           <Stack
    //             direction={"row"}
    //             alignItems="center"
    //             justifyContent={"space-between"}
    //             width={1}
    //           >
    //             <Typography variant="h6" fontWeight={600}>
    //               {t("alternativeChannelEndDate")}
    //             </Typography>
    //             <Typography variant="body1">
    //               {new Date(
    //                 donationDetail?.donation?.consumeByDate + "Z"
    //               ).toLocaleString("pt-PT", {
    //                 day: "numeric",
    //                 month: "numeric",
    //                 year: "numeric",
    //                 hour: "numeric",
    //                 minute: "numeric",
    //                 formatMatcher: "best fit",
    //                 timeZone: currentTimeZone,
    //               })}
    //             </Typography>
    //           </Stack>
    //         )}
    //       </Stack>
    //     )}
    //   </Stack>

    //   <Stack direction="column" gap="6px" pb={4}>
    //     <Typography variant="h6" color={"text.secondary"} fontWeight={600}>
    //       {t("pickupLocation")}
    //     </Typography>
    //     <Stack mt={2} direction={"column"} gap={1}>
    //       <Stack
    //         direction={"column"}
    //         alignItems="flex-start"
    //         justifyContent={"space-between"}
    //       >
    //         <Typography variant="h6" fontWeight={600}>
    //           {t("addressTitle")}
    //         </Typography>
    //         <Typography variant="body1">
    //           {donationDetail?.addresses[0]?.addressTitle}
    //         </Typography>
    //       </Stack>
    //       <Stack
    //         direction={"column"}
    //         alignItems="flex-start"
    //         justifyContent={"space-between"}
    //       >
    //         <Typography variant="h6" fontWeight={600}>
    //           {t("houseHold")}
    //         </Typography>
    //         <Typography variant="body1">
    //           {donationDetail?.addresses[0]?.addressLine}
    //         </Typography>
    //       </Stack>
    //       <Stack
    //         direction={"column"}
    //         alignItems="flex-start"
    //         justifyContent={"space-between"}
    //       >
    //         <Typography variant="h6" fontWeight={600}>
    //           {t("district")}
    //         </Typography>
    //         <Typography>{donationDetail?.addresses[0]?.district}</Typography>
    //       </Stack>
    //       <Stack
    //         direction={"column"}
    //         alignItems="flex-start"
    //         justifyContent={"space-between"}
    //       >
    //         <Typography variant="h6" fontWeight={600}>
    //           {t("county")}
    //         </Typography>
    //         <Typography>{donationDetail?.addresses[0]?.county}</Typography>
    //       </Stack>
    //       <Stack
    //         direction={"column"}
    //         alignItems="flex-start"
    //         justifyContent={"space-between"}
    //       >
    //         <Typography variant="h6" fontWeight={600}>
    //           {t("parshi")}
    //         </Typography>
    //         <Typography>{donationDetail?.addresses[0]?.subDivision}</Typography>
    //       </Stack>
    //       <Stack
    //         direction={"column"}
    //         alignItems="flex-start"
    //         justifyContent={"space-between"}
    //       >
    //         <Typography variant="h6" fontWeight={600}>
    //           {t("postalCode")}
    //         </Typography>
    //         <Typography>{donationDetail?.addresses[0]?.postalCode}</Typography>
    //       </Stack>
    //       <Stack
    //         direction={"column"}
    //         alignItems="flex-start"
    //         justifyContent={"space-between"}
    //       >
    //         <Typography variant="h6">{t("locality")}</Typography>
    //         <Typography>{donationDetail?.addresses[0]?.locality}</Typography>
    //       </Stack>
    //       <Stack
    //         direction={"column"}
    //         alignItems="flex-start"
    //         justifyContent={"space-between"}
    //       >
    //         <Typography
    //           color="primary"
    //           sx={{ textDecoration: "underline" }}
    //           component="span"
    //         >
    //           {donationDetail?.addresses[0]?.latitude},
    //           {donationDetail?.addresses[0]?.longitude}
    //         </Typography>
    //       </Stack>
    //     </Stack>
    //   </Stack>
    //   <Stack direction="column" gap="6px" pb={4}>
    //     <Typography
    //       variant="h6"
    //       color={"text.secondary"}
    //       fontWeight={600}
    //       textTransform={"capitalize"}
    //     >
    //       {t("observations")}
    //     </Typography>
    //     <Typography variant="body1">
    //       {donationDetail?.donation?.note
    //         ? donationDetail?.donation?.note
    //         : "Sem observações"}
    //     </Typography>
    //   </Stack>
    // </Box>
  );
};

export default Detail;
